import { AuthScreenShell } from '@/components/auth-screen-shell';
import { SignUpForm } from '@/components/sign-up-form';
import { useLocalSearchParams } from 'expo-router';

export default function SignUpScreen() {
  const { returnTo } = useLocalSearchParams<{ returnTo?: string | string[] }>();
  return (
    <AuthScreenShell>
      <SignUpForm returnTo={returnTo} />
    </AuthScreenShell>
  );
}
